module.exports = __webpack_public_path__ + "assets/nuxtjs.2a87194b.svg";